import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=c820294a&scoped=true"
import script from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=c820294a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c820294a",
  null
  
)

export default component.exports